import {
  ListSnapshotObjectsRequest,
  ListSnapshotObjectsResponse,
  PresignedUrlRequest,
  PresignedUrlResponse,
} from "./models/snapshotModels";
import { callApiGw } from "../auth/ApiClient";

const snapshotGetPresignedUrlEndpoint = "snapshot/get-presigned-url";
const snapshotListObjectsEndpoint = "snapshot/list-objects";

export async function getSnapshotPresignedUrl(request: PresignedUrlRequest) {
  const presignedUrlHttpResponse = await callApiGw(snapshotGetPresignedUrlEndpoint, "POST", { body: request });
  const presignedUrlResponse: PresignedUrlResponse = await presignedUrlHttpResponse.json();
  return presignedUrlResponse;
}

export async function uploadFileToS3(presignedUrl: string, data: Uint8Array, contentType: string) {
  const headers = new Headers({
    "Content-Type": contentType,
  });
  const response = await fetch(presignedUrl, {
    method: "PUT",
    headers: headers,
    body: data,
  });
  return response.ok;
}

export async function listSnapshotS3Objects(request: ListSnapshotObjectsRequest) {
  const listSnapshotHttpResponse = await callApiGw(snapshotListObjectsEndpoint, "GET", { urlParams: request });
  const listSnapshotResponse: ListSnapshotObjectsResponse = await listSnapshotHttpResponse.json();
  return listSnapshotResponse;
}
